module.exports = __webpack_public_path__ + "img/time-icon.332e24e1.svg";